<template>
    <div class="calc-form" :style="{width: noSideText ? '100%' : '65%'}">
        <div class="delivery-line options-line radius-4 align-items-start" @keydown.tab="handleTabKey">
            <div class="options-line-column position-relative">
                <label class="options-line-label"><span>1</span>{{ $helper.trans('Take_From') }}:</label>
                <div class="options-navig-block">
                    <price-calculator-country-selector
                        input-type="from"
                        :disabled="!isImport && !bothNonLt"
                    ></price-calculator-country-selector>
                    <div class="options-navig-column options-small-column" v-show="$helper.needsCity().from">
                        <select2-component
                            v-if="$helper.needsCity()['from'] && $store.state.computed.citiesArray.from.length > 0"
                            :values="$store.state.computed.citiesArray.from"
                            :placeholder="'* '+$helper.trans('City')"
                            :noLang="true"
                            :useIndexes="false"
                            classes="input-big select-style-ups select2-vue from_city_input"
                            v-model="$store.state.shipperAddressInformation.city" 
                            dropDownClass="select2-with-search"
                            :lowerCaseIndices="false"
                            customId="shipperCitySelect2"
                        ></select2-component>
                        <input v-else type="text" :placeholder="$helper.trans('City')" v-model="$store.state.shipperAddressInformation.city" id="city_from" class="input-big from_city_input">
                    </div>
                    <div class="options-navig-column options-small-column" v-show="!$helper.needsCity().from">
                        <input type="text" @input="$helper.validatePostCode($store.state.from.postCode, $store.state.from.country, 'post_code_from');" id="post_code_from" :placeholder="$helper.trans('Zip_code')" v-model="$store.state.from.postCode" class="input-big from_postCode_input">
                    </div>
                </div>
                <i v-if="$store.state.$siteSettings['Logged_in']" class="select-address-icon" @click="openAddressSelectorModal(isImport ? 'receiver' : 'user');"></i>
            </div>
            <div class="reverse-block" style="margin-top: 7% !important;">
                <button tabindex="-1" class="btn-reverse" type="button" @click="reverseCountriesAndPostCodes();">
                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 15L5 11M5 5H17H5ZM17 5L13 1L17 5ZM17 5L13 9L17 5ZM13 15H1H13ZM1 15L5 19L1 15Z" stroke="#330000" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
            <div class="options-line-column position-relative">
                <label class="options-line-label"><span>2</span>{{ $helper.trans('Delivery_to') }}:</label>
                <div class="options-navig-block">
                    <price-calculator-country-selector
                        input-type="to"
                        :disabled="(isImport && !bothNonLt) || $store.state.customValues.lockedToCountry"
                    ></price-calculator-country-selector>
                    <div class="options-navig-column options-small-column" v-show="$helper.needsCity().to">
                        <select2-component
                            v-if="$helper.needsCity()['to'] && $store.state.computed.citiesArray.to.length > 0"
                            :values="$store.state.computed.citiesArray.to"
                            :placeholder="'* '+$helper.trans('City')"
                            :noLang="true"
                            :useIndexes="false"
                            classes="input-big select-style-ups select2-vue to_city_input"
                            v-model="$store.state.deliveryAddressInformation.city" 
                            dropDownClass="select2-with-search"
                            :lowerCaseIndices="false"
                            customId="deliveryCitySelect2"
                        ></select2-component>
                        <input v-else type="text" :placeholder="$helper.trans('City')" v-model="$store.state.deliveryAddressInformation.city" id="city_to" class="input-big to_city_input">
                    </div>
                    <div class="options-navig-column options-small-column" v-show="!$helper.needsCity().to">
                        <input type="text" @input="$helper.validatePostCode($store.state.to.postCode, $store.state.to.country, 'post_code_to');" id="post_code_to" :placeholder="$helper.trans('Zip_code')" v-model="$store.state.to.postCode" class="input-big to_postCode_input">
                    </div>
                </div>
                <i v-if="$store.state.$siteSettings['Logged_in']" class="select-address-icon" @click="openAddressSelectorModal(isImport ? 'user' : 'receiver');"></i>
            </div>
        </div>

        <div class="delivery-line options-line radius-4">
            <div class="packet-line">
                <div class="options-line-column-full-with">
                    <label class="options-line-label">
                        <span>3</span>
                        {{ $helper.trans('Package') }}
                        <i class="fa fa-question-circle info-question-circle">
                            <div class="custom-popover-wrapper">
                                <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Package_type_info')"></div>
                            </div>
                        </i>
                    </label>
                    <div class="options-navig-block packageType_input">
                        <div class="options-navig-column custom-radio-border">
                            <input type="radio" value="01" id="packet-1" class="input-country input-big" v-model="$store.state.packageType">
                            <label for="packet-1" id="label-packet-1">{{ $helper.trans('Calculator_envelope') }}</label>
                        </div>
                        <div class="options-navig-column custom-radio-border">
                            <input type="radio" value="04" id="packet-3" class="input-country input-big" v-model="$store.state.packageType">
                            <label for="packet-3" id="label-packet-3">{{ $helper.trans('UPS_Package') }}</label>
                        </div>
                        <div class="options-navig-column custom-radio-border">
                            <input type="radio" value="02" id="packet-2" class="input-country input-big" v-model="$store.state.packageType">
                            <label for="packet-2" id="label-packet-2">{{ $helper.trans('Box') }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="delivery-line options-line radius-4">
            <div class="packet-size">
                <div class="options-line-column-full-with">
                    <label class="options-line-label">
                        <span>4</span>
                        {{ $helper.trans('Package_dimensions') }}
                        <i class="fa fa-question-circle info-question-circle">
                           <div class="custom-popover-wrapper">
                                <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Pak_dimensions_info')"></div>
                           </div>
                        </i>
                    </label>

                    <package-dimensions-line
                        v-for="(packagesDimension, packageIndex) in $store.state.packagesDimensions" :key="packageIndex" :index="packageIndex"
                    ></package-dimensions-line>
                    <div class="mt-3 maximum-packets-warning" style="display: none;">
                        <p class="alert alert-danger">{{ $helper.trans('Reached_maximum_packets_limit') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="send-block">
            <button type="button" @click="initialCalculatorFormSubmit();" class="btn btn-yellow radius-4">{{ $helper.trans('Calculate_price') }}</button>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    props: {
        noSideText: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        initialCalculatorFormSubmit: async function(){
            let vueThis = this;  

            // NOTE Set Malta city
            if(vueThis.$store.state.from.country === 'mt'){
                vueThis.$store.state.shipperAddressInformation.city = vueThis.$helper.getMaltaCity(vueThis.$store.state.from.postCode);
            }
            if(vueThis.$store.state.to.country === 'mt'){
                vueThis.$store.state.deliveryAddressInformation.city = vueThis.$helper.getMaltaCity(vueThis.$store.state.to.postCode);
            }

            if (!vueThis.$store.state.inClientAdmin) {
                if (vueThis.$store.state.from.country === 'ma') {
                    vueThis.$store.state.from.postCode = vueThis.$helper.getMoroccoPostCode(vueThis.$store.state.shipperAddressInformation.city);
                }
                if (vueThis.$store.state.to.country === 'ma') {
                    vueThis.$store.state.to.postCode = vueThis.$helper.getMoroccoPostCode(vueThis.$store.state.deliveryAddressInformation.city);
                }
            }

            let valid = await vueThis.$helper.validate(['countriesFrom', 'countriesTo', 'packages'], {
                from: {
                    ...vueThis.$store.state.from,
                    city: vueThis.$store.state.shipperAddressInformation.city,
                },
                to: {
                    ...vueThis.$store.state.to,
                    city: vueThis.$store.state.deliveryAddressInformation.city,
                },
                packageType: vueThis.$store.state.packageType,
                packages: vueThis.$store.state.packagesDimensions,
            });
            if(!valid){
                return;
            }

            $('.content-section').hide();       

            if (!this.$store.state.checkOutSteps.first) {                
                this.$helper.pushDataLayer(1);        
                this.$store.state.checkOutSteps.first = true;
            }
            
            vueThis.$store.state.calculatorState = 'senderServiceSelector';
        },
        reverseCountriesAndPostCodes: function(){
            if(this.$store.state.customValues.lockedToCountry){
                return;
            }

            let oldFrom = this.$store.state.from;
            this.$store.state.from = structuredClone(this.$store.state.to);
            this.$store.state.to = oldFrom;

            let oldAddress = this.$store.state.shipperAddressInformation;
            this.$store.state.shipperAddressInformation = structuredClone(this.$store.state.deliveryAddressInformation);
            this.$store.state.deliveryAddressInformation = oldAddress;

            this.$helper.validatePostCode(this.$store.state.from.postCode, this.$store.state.from.country, 'post_code_from');
            this.$helper.validatePostCode(this.$store.state.to.postCode, this.$store.state.to.country, 'post_code_to');

            this.$store.state.awaitingActions.resetShippings = true;
        },
        openAddressSelectorModal: function(addressType){
            this.$store.state.addressSelectorType = addressType;
            $('#address_selector_modal').modal('show');
        },
        handleTabKey: function(event) {            
            let vueThis = this;                   
            if($(event.target).hasClass('from_postCode_input')) {
                $('.to_country_input').select2("open");
                setTimeout(function() {
                    vueThis.$helper.addFocus();
                }, 100);
            }  
        },
    },
    computed:{
        isImport(){
            return this.$store.state.to.country === 'lt';
        },
        bothNonLt(){
            return this.$store.state.from.country !== 'lt' && this.$store.state.to.country !== 'lt';
        },
    },
    watch: {
        '$store.state.awaitingActions.forceUpdate.initialCalculatorForm': function(){
            if(!this.$store.state.awaitingActions.forceUpdate.initialCalculatorForm){
                return;
            }
            this.$store.state.awaitingActions.forceUpdate.initialCalculatorForm = false;
        },
        '$store.state.shipperAddressInformation.city': function(){
            let regex = /\d/i;
            if(regex.test(this.$store.state.shipperAddressInformation.city)){
                this.$helper.showError(this.$helper.trans('Present_city'), $('#city_from'));
            } else{
                $(`#city_from`).removeClass('alert-danger-ups').parent().removeClass('custom-ups-error-parent').find('span.ups-danger-text').remove();
            }
        },
        '$store.state.deliveryAddressInformation.city': function(){
            let regex = /\d/i;
            if(regex.test(this.$store.state.deliveryAddressInformation.city)){
                this.$helper.showError(this.$helper.trans('Present_city'), $('#city_to'));
            } else{
                $(`#city_to`).removeClass('alert-danger-ups').parent().removeClass('custom-ups-error-parent').find('span.ups-danger-text').remove();
            }
        },      

    }
    
}
</script>
